import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Role } from "../constants/Role";
import KeycloakService from "../services/KeycloakService";
import {
  ReadOutlined,
  LogoutOutlined,
  ProfileOutlined,
  LoginOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu, Dropdown, Divider } from "antd";
/**
 * Navigation component for the application
 */
const AdminNavbar = () => {
  const { authenticated, hasRole, hasAnyRole, login, logout, userProfile } =
    useAuth();
  const navigate = useNavigate();

  // Kiểm tra nếu là mentor
  const isMentor = hasRole && hasRole(Role.STAFF_COURSE_MENTOR);

  // Handle login button click
  const handleLogin = () => {
    login();
  };

  // Handle logout button click
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // Handle profile click to open Keycloak account management
  const handleProfileClick = () => {
    const keycloak = KeycloakService.getKeycloak();
    const accountUrl = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/account`;
    window.open(accountUrl, '_blank');
  };

  const userMenu = (
    <div style={{ padding: "12px", width: "200px" }}>
      <Menu>
        <Menu.Item>
          <div style={{ fontWeight: 600, color: "Gray" }}>
            {authenticated && userProfile && (
              <div style={{ fontSize: "15px" }}>
                <span>
                  {userProfile?.firstName || userProfile?.given_name}{" "}
                  {userProfile?.lastName || userProfile?.family_name}
                </span>
              </div>
            )}
          </div>
        </Menu.Item>
        <Divider style={{ margin: "12px 0" }} />
        <Menu.Item
          key="profile"
          icon={<ProfileOutlined />}
          onClick={handleProfileClick}
        >
          Profile
        </Menu.Item>
        <Menu.Item
          key="logout"
          icon={<LogoutOutlined />}
          onClick={handleLogout}
        >
          Logout
        </Menu.Item>
      </Menu>
    </div>
  );

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" className="navbar-logo">
          <ReadOutlined /> JetSkill
        </Link>
      </div>

      <div className="navbar-menu">
        <div className="navbar-start">
          {!isMentor && (
          <Link to="/" className="navbar-item">
            Dashboard
          </Link>
          )}

          {authenticated && hasAnyRole([Role.ADMIN_DEV, Role.ADMIN_BUSINESS]) && (
            <Link to="/manage/categories" className="navbar-item">
              Manage Categories
            </Link>
          )}

          {authenticated &&
            hasAnyRole([Role.ADMIN_DEV, Role.ADMIN_BUSINESS, Role.STAFF_COURSE_MANAGER]) && (
              <Link to="/manage/courses" className="navbar-item">
                Manage Courses
              </Link>
            )}
            {authenticated &&
            hasAnyRole([Role.ADMIN_DEV, Role.STAFF_ACCOUNTING]) && (
              <Link to="/manage/orders" className="navbar-item">
                Manage Orders
              </Link>
            )}
        </div>

        <div className="navbar-end">
          {authenticated ? (
            <div className="navbar-item user-info">
              <Dropdown
                overlay={userMenu}
                placement="bottomRight"
                trigger={["hover"]}
              >
                <UserOutlined className="navbar-icon" style={{ cursor: "pointer" }} />
              </Dropdown>
            </div>
          ) : (
            <button
              className="login-button"
              icon={<LoginOutlined />}
              onClick={handleLogin}
            >
              Login
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
